export class Terms {
    constructor() {
        console.log('called');
        const terms = document.querySelectorAll('input[name="terms[]"]');
        terms.forEach((term)=>{
            term.addEventListener('change', this.termsEventHandler);
        });
    }
    termsEventHandler() {
        const terms = document.querySelectorAll('input[name="terms[]"]');
        const submitButton = document.querySelector('button[type="submit"]');
        for(let i=0; i<terms.length; i++){
            if (!terms[i].checked) {
                submitButton.disabled = true;
                break;
            }
            submitButton.disabled = false;
        }
    }
}